module.exports = __webpack_public_path__ + "img/award-5.d1e364d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards/award-5.jpg
// module id = 1191
// module chunks = 1